import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
`;
